export default __webpack_public_path__ + "static/media/selected_tractor_nouser.73cdf08e.svg";